import React, { useState, useEffect } from 'react';
import SearchDropdown from './searchDropdown';
import { jobFilterStatusOptions } from '../../initial-values';

interface Props {
  selectedStatus?: any;
  setSelectedStatus?: any;
  setHandleToggleChange?: any;
  dummyOption?: any;
  label?: any;
  statusesFilter?: any;
}
const SelectStatusDropdown = ({
  selectedStatus,
  setSelectedStatus,
  setHandleToggleChange,
  label,
  dummyOption,
  statusesFilter = (status: any) => true,
}: Props) => {
  const [statusList, setStatusList] = useState<any>();

  useEffect(() => {
    let usersData = jobFilterStatusOptions.filter(statusesFilter);
    const formattedUsersList: any = usersData.map((item: any) => ({
      label: item.name,
      value: item.value,
    }));
    setStatusList(formattedUsersList);
  }, []);
  return (
    <SearchDropdown
      id={'status-dropdown'}
      placeholder={dummyOption ? dummyOption : 'All'}
      selectedValue={selectedStatus}
      label={label && label}
      dummyOptionText={dummyOption ? dummyOption : 'All'}
      options={statusList && statusList}
      onSelect={(item) => {
        setSelectedStatus(item.value);
        setHandleToggleChange(true);
      }}
    />
  );
};

export default SelectStatusDropdown;
